<template>
    <!-- We normally use this icon with tooltip inline, e.g. in a label or next to some other heading/term that may need explanation. -->
    <!-- It's available globally using <help-icon tooltip="Your tooltip text here" /> -->
    <i
        :class="`bi bi-question-circle-fill text-${bsColour} ms-1`"
        data-bs-toggle="tooltip"
        :data-bs-placement="placement"
        :data-bs-html="html"
        :title="tooltip"
    ></i>
</template>

<script>
export default {
    name: "HelpIcon",

    props: {
        // The tooltip text
        tooltip: {
            type: String,
            required: true,
        },

        bsColour: {
            type: String,
            default: "black",
        },

        placement: {
            type: String,
            default: "top",
        },

        // Whether to allow HTML in the tooltip content - if true, the tooltip content will be rendered as HTML, allowing for formatting and links. If false, the tooltip content will be treated as plain text.
        html: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped></style>
